var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDairectMonogramDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 92 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -100,
    y: -100,
    width: 292,
    height: 300
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(50px)",
      clipPath: "url(#bgblur_0_605_99_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    "data-figma-bg-blur-radius": 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3414 97.8806L60.9464 0H31.0536L0.701448 97.743L0 100H34.8519L46.0015 89.0238L57.1512 100H92L91.3414 97.8806ZM46.0015 68.729L16.2865 97.7797L46.0015 2.11634L75.7135 97.7797L46.0015 68.729Z",
    fill: "var(--fill-0, white)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9805 0.5L45.5244 1.96777L15.8086 97.6318L16.6357 98.1367L46.001 69.4277L75.3643 98.1367L76.1914 97.6318L46.4795 1.96777L46.0234 0.5H60.5781L90.8643 98.0293L91.3213 99.5H57.3564L46.3525 88.667L46.002 88.3223L45.6504 88.667L34.6465 99.5H0.678711L1.17871 97.8916L31.4219 0.5H45.9805Z",
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_605_99_clip_path",
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3414 97.8806L60.9464 0H31.0536L0.701448 97.743L0 100H34.8519L46.0015 89.0238L57.1512 100H92L91.3414 97.8806ZM46.0015 68.729L16.2865 97.7797L46.0015 2.11634L75.7135 97.7797L46.0015 68.729Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairectMonogramDesktop);
export default __webpack_public_path__ + "static/media/dairect-monogram-desktop.5e126f278a9064d86c7df9d72e092960.svg";
export { ForwardRef as ReactComponent };